import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-option',
  templateUrl: './custom-option.component.html',
  styleUrls: ['./custom-option.component.scss'],
})
export class CustomOptionComponent implements OnInit {
  @Input() icon: string = '';
  @Input() heading: string = 'heading';
  @Input() subHeading: string = 'subHeading';

  ngOnInit() {}
}
